import React, { useCallback } from 'react';
import { NavLink } from 'react-router-dom';

type Props = {
    to: string,
    children: JSX.Element | JSX.Element[],
    className?: string,
    activeClass?: string,
    pendingClass?: string,
    onClick?: () => void,
};

export const NavigationLink = (props: Props) => {
    const {
        to,
        activeClass = 'active',
        pendingClass = 'pending',
        className,
        children,
        onClick,
    } = props;

    const navLinkClassName = ({ isActive, isPending }) => {
        return `${className ? className : ''} ${isActive ? activeClass : isPending ? pendingClass : ''}`;
    };

    const handleClick = useCallback(() => {
        if (onClick) {
            onClick();
        }
    }, [onClick]);

    return (
        <NavLink to={to} className={navLinkClassName} onClick={handleClick}>
            {children}
        </NavLink>
    );
};
